(function () {

    var postMessageHandler = function () {

        var self = this;

        self.__callback = function (e) {

            Object.keys(self.__events).forEach(function (key) {

                var callback = self.__events[key];

                if (typeof (callback) === 'function') {

                    callback(e, e.data);

                }

            });

        };
        self.__events = {};

        if (!!!window['postMessage']) {

            throw new Error('window.postMessage is not supported!');

        }

        window.addEventListener('message', self.__callback, false);
    };

    postMessageHandler.prototype.subscribe = function (name, callback) {

        var self = this;

        if (!!!callback
            || typeof (callback) !== 'function') {

            throw new Error('invalid callback parameter');

        }

        if (!!self.__events[name]) {

            throw new Error('Event is already registered with name ' + name);

        }

        self.__events[name] = callback;

    };

    postMessageHandler.prototype.unsubscribe = function (name, callback) {

        var self = this;

        if (!!!self.__events[name]) {

            return;

        }

        delete self.__events[name];
    };

    postMessageHandler.prototype.destroy = function () {

        var self = this;

        window.removeEventListener('message', self.__callback, false);
        self.__events = undefined;

    }

    window.PostMessages = new postMessageHandler();

})();